import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {Cockpit} from 'shared/dtos/cockpit/cockpit';
import {KennzahlenZurMethodik} from 'shared/dtos/cockpit/kennzahlen-zur-methodik';
import {DataResult} from 'shared/dtos/data-result';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {
  CockpitChartComponent,
  CockpitChartParentComponentWithCurrentLocale,
  CockpitContentComponent
} from '../../cockpit-shared/cockpit-content-component';
import {KoefUndIntervalle} from 'shared/dtos/cockpit/charts/geschaetzteKoeffKonfidenzintervalle';
import {Charts} from 'shared/dtos/cockpit/charts/charts';
import {GeschaetzteKoeffizientenKonfidenzintervalleComponent} from './geschaetzte-koeffizienten-konfidenzintervalle/chart-geschaetzte-koeffizienten-konfidenzintervalle.component';

@Component({
  selector: 'app-kennzahlen-methodik',
  templateUrl: './kennzahlen-methodik.component.html',
  styleUrl: './kennzahlen-methodik.component.scss',
  standalone: false
})
export class ChartDialogKennzahlenMethodikComponent
  extends CockpitChartParentComponentWithCurrentLocale
  implements OnInit, AfterViewInit, CockpitContentComponent
{
  @ViewChild(GeschaetzteKoeffizientenKonfidenzintervalleComponent)
  chartChild!: CockpitChartComponent;

  kennzahlenZurMethodik: KennzahlenZurMethodik;
  koeffKonfidenzintervalle: KoefUndIntervalle;
  dataResult: DataResult;
  card: CockpitCard;
  chartChildren: CockpitChartComponent[];
  tableHeaders = [
    'i18n.cockpit.card.chart.KennzahlenZurMethodik.regressionsergebnisse',
    'i18n.cockpit.card.chart.KennzahlenZurMethodik.testLohndifferenzsignifikant'
  ];

  constructor(
    private readonly dataStorageService: DataStorageService,
    private readonly tableDataExport: TableExportService,
    protected readonly translate: TranslateService
  ) {
    super(translate);
    this.kennzahlenZurMethodik = new KennzahlenZurMethodik();
  }

  async ngOnInit() {
    super.ngOnInit();

    this.koeffKonfidenzintervalle = (
      (await this.dataStorageService.getChartsData()) as Charts
    )?.koefUndIntervalle;

    this.kennzahlenZurMethodik = (
      (await this.dataStorageService.getCockpitData()) as Cockpit
    )?.kennzahlenZurMethodik;
    this.dataResult =
      (await this.dataStorageService.getResultData()) as DataResult;
  }

  ngAfterViewInit(): void {
    this.chartChildren = [this.chartChild];
  }
  async exportCardData() {
    this.tableDataExport.exportAllHtmlTablesInDom(
      'i18n.cockpit.card.KennzahlenZurMethodik.title',
      [
        'i18n.cockpit.card.chart.KennzahlenZurMethodik.regressionsergebnisse',
        'i18n.cockpit.card.chart.KennzahlenZurMethodik.testLohndifferenzsignifikant'
      ]
    );
  }
}
